<div class="show-confirm">
  <div class="animated fadeIn">
    <h4 class="show-confirm__title">Are you sure?</h4>
    <div class="show-confirm__actions">
      <button class="show-confirm__cancel" (click)="isConfirmed(false)">No</button>
      <button class="show-confirm__confirm" (click)="isConfirmed(true)">Yes</button>
    </div>
  </div>
</div>
